export const titles = {
  campaignRegistry: 'Campaign Registry',
  pmsSync: 'PMS sync',
  tripAdvisor: 'TripAdvisor',
  reviewSettings: 'Review settings',
  bookingEngine: 'Booking engine',
  billingInvoiceAdress: 'Billing & invoice address',
  hostedMessaging: 'Hosted messaging',
  phoneNumber: 'Phone number',
  logoAndcolors: 'Brand logo and colors',
  initialPayment: 'Initial payment',
  chatbotResponses: 'Chatbot responses',
  otaPromo: 'OTA promo',
  directPromo: 'Direct promo',
  users: 'Users',
  enabledCampaigns: 'Enabled campaigns',
  marketingURL: 'Marketing URL',
  domain: 'Domain'
}

export const onboardingIssues = [
  {
    onboardingGroupTitle: 'Mandatory Steps',
    onboardingIssues: [
      {
        title: titles.campaignRegistry
      },
      {
        title: titles.pmsSync
      },
      {
        title: titles.tripAdvisor
      },
      {
        title: titles.reviewSettings
      },
      {
        title: titles.bookingEngine
      },
      {
        title: titles.billingInvoiceAdress
      },
      {
        title: titles.phoneNumber
      },
      {
        title: titles.logoAndcolors
      }
    ]
  },
  {
    onboardingGroupTitle: 'Optional Steps',
    onboardingIssues: [
      {
        title: titles.hostedMessaging
      },
      {
        title: titles.chatbotResponses
      },
      {
        title: titles.otaPromo
      },
      {
        title: titles.directPromo
      },
      {
        title: titles.users
      },
      {
        title: titles.enabledCampaigns
      },
      {
        title: titles.domain
      },
      {
        title: titles.marketingURL
      }
    ]
  }
]

export const onboardingStatusTitles = {
  HotelConfigurationStage: 'Hotel Configuration Stage',
  HotelSetupStage: 'Hotel Setup Stage',
  InitialPaymentStage: 'Initial Payment Stage'
}
